import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { parseDateTime, startOfMonth } from "shared/src/date.mjs";
import * as f from "../../utils/formatter";
import dayjs from "dayjs";

function toDayJs(v) {
  if (v == null) {
    return null;
  }

  return dayjs(v);
}

function months() {
  const startOfMonth = new Date();
  startOfMonth.setDate(1);
  startOfMonth.setHours(0, 0, 0, 0);

  return Array.from(new Array(12).keys()).map((add) => {
    const d = new Date(startOfMonth.getTime());
    d.setMonth(d.getMonth() + add);

    return d;
  });
}

export default function MonthSelector({
  setReservationSettingState,
  renderedMonths,
}) {
  const theme = useTheme();

  const visibleMonths = new Set(
    renderedMonths.map((s) => startOfMonth(parseDateTime(s)).getTime()),
  );

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.dark,
        mb: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
        px: 0.5,
      }}
    >
      {months().map((month, i) => {
        const active = visibleMonths.has(month.getTime());

        return (
          <Button
            onClick={() => {
              const nextMonth = new Date(month.getTime());
              setReservationSettingState((prev) => ({
                ...prev,
                calendarRange: [month, nextMonth].map((m) => toDayJs(m)),
              }));
            }}
            key={i}
            variant="contained"
            className={active ? "month-selector_btn--active" : ""}
            sx={{
              minWidth: "2rem",
              padding: "0 1.5rem",
              color: active ? theme.palette._components.heading.color : "white",
              backgroundColor: active
                ? theme.palette.primary.main
                : "transparent",
              my: 0.5,
              "&.month-selector_btn--active:has(+ .month-selector_btn--active)":
                {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                },
              ".month-selector_btn--active + &.month-selector_btn--active": {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              },
            }}
          >
            <Typography variant="body2">{f.shortMonth(month)}</Typography>
          </Button>
        );
      })}
    </Box>
  );
}
